import { useState } from "react";
import CustomerService from "../../rest/customerService";
import AssetsService from "../../rest/assetsService";
import { AiOutlineLoading, AiOutlineUser } from "react-icons/ai";

export const ClientAvatarTooltip = ({ clientString }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [loadingImg, setLoadingImg] = useState(false);
    const [imageData, setImageData] = useState(null);

    const parts = clientString ? clientString.split('/') : [];
    const login = parts[0]?.trim();
    const name = parts[1]?.trim() || "Cliente";

    const fetchImage = async () => {
        if (imageData || loadingImg) return;
        setLoadingImg(true);
        try {
            const studentData = await CustomerService.getSpecificStudent(login);
            if (studentData && studentData.image_url) {
                const imgBlob = await AssetsService.getProfileImage(studentData.image_url);
                setImageData(imgBlob);
            }
        } catch (err) { } finally { setLoadingImg(false); }
    };

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => { setIsOpen(true); fetchImage(); }}
            onMouseLeave={() => setIsOpen(false)}
            onClick={() => { setIsOpen(!isOpen); fetchImage(); }}
        >
            <h4 className="font-bold text-gray-800 line-clamp-1 text-sm md:text-base cursor-pointer hover:text-custom_blue underline decoration-dotted underline-offset-4 decoration-slate-300">
                {name}
            </h4>
            {isOpen && (
                <div className="absolute top-full left-0 mt-2 w-32 h-32 bg-white rounded-xl shadow-2xl border-2 border-custom_blue z-[999] flex items-center justify-center overflow-hidden animate-in fade-in zoom-in duration-200">
                    {loadingImg ? <AiOutlineLoading className="animate-spin text-custom_blue text-2xl" /> :
                        imageData ? <img src={imageData} alt={name} className="w-full h-full object-cover" /> :
                            <div className="flex flex-col items-center text-gray-400 p-2 text-center"><AiOutlineUser size={32} /><span className="text-[10px]">Sem foto</span></div>}
                </div>
            )}
        </div>
    );
};